function decimalToDMS(value, isLatitude = true) {
  const decimal = parseFloat(value);
  if (isNaN(decimal)) return "N/A";

  const direction =
    decimal >= 0 ? (isLatitude ? "N" : "E") : isLatitude ? "S" : "W";

  const absDecimal = Math.abs(decimal);
  const degrees = Math.floor(absDecimal);
  const minutesDecimal = (absDecimal - degrees) * 60;
  const minutes = Math.floor(minutesDecimal);
  const seconds = (minutesDecimal - minutes) * 60;

  return `${degrees}°${String(minutes).padStart(2, "0")}'${seconds
    .toFixed(1)
    .padStart(4, "0")}"${direction}`;
}

export default decimalToDMS;
